module.exports = __webpack_public_path__ + "fb0508aabb129ec1416b5ad2c4f94bc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/buyer.svg
// module id = 3633
// module chunks = 6